import axios from 'axios';
import React from 'react'
import { useState, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Logo from './img/logo/TC-LOGO.png';
import { useStateValue } from './StateProvider';
import './VerifyCode.css';

function VerifyCode() {

  const [{ email }, dispatch] = useStateValue();

  const [verificationCode, setVerificationCode] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [counter, setCounter] = useState(0);
  const history = useHistory();

  function useInterval(callback, delay) {

    const savedCallback = useRef();
   
     // Remember the latest callback.
     useEffect(() => {
       savedCallback.current = callback;
     }, [callback]);
   
     // Set up the interval.
     useEffect(() => {
       let id = setInterval(() => {
         savedCallback.current();
       }, delay);
       return () => clearInterval(id);
     }, [delay]);
 
     
   }
 
   useInterval(() => {
     setCounter(counter + 1);
   }, 1000);

   useEffect(() => {
    if(counter === 5){
        document.getElementById("587").style.display = "none";
        document.getElementById("727").style.display = "none";
        document.getElementById("465").style.display = "none";
    }
   }, [counter])

  const onSubmit = () =>{
    if(verificationCode === ''){
      document.getElementById("587").style.display = "block";
      document.getElementById("__307").style.border = "1px solid red"
      setCounter(0)
    }
    else{
      axios
          .get('https://toycityzimbabwe.com/backend/checkCode.php', {params: { verificationCode }} )
          .then(res => {
              validCode(res.data)
          })
          .catch( error => {
              console.log(error)
          });
    }
  }

  const onSubmitPass = () =>{
    if(password === ''){
      document.getElementById("727").style.display = "block";
      document.getElementById("__727").style.border = "1px solid red";
      setCounter(0);
    }else if(password !== confirm){
      document.getElementById("465").style.display = "block";
      document.getElementById("__727").style.border = "1px solid red";
      document.getElementById("__737").style.border = "1px solid red";
      setCounter(0);
    }
    else{
      axios
          .get('https://toycityzimbabwe.com/backend/postChangePassword.php',{params: { email, password }} )
          .then(res => {
          })
          .catch( error => {
              console.log(error)
          });

          history.push('/signin')
        
      dispatch({
        type: 'SET_EMAIL',
        email: []
      }) 
      }
  }

  const onSubmitResend = () =>{
    if(email === ''){
      console.log("Email empty")
    }
    else{
      axios
        .get('https://toycityzimbabwe.com/backend/sendEmail.php',{params: { email }} )
        .then(res => {
        })
        .catch( error => {
            console.log(error)
        });
    }
  }

  function validCode(user){

    if(user.length === 0){
      document.getElementById("587").style.display = "block";
      document.getElementById("__307").style.border = "1px solid red"
      setCounter(0)
    }
    else{
      document.getElementById("__307").style.display = "none";
      document.getElementById("_237").style.display = "none";
      document.getElementById("_238").style.display = "none";
      document.getElementById("_239").style.display = "none";
      document.getElementById("__727").style.display = "block";
      document.getElementById("__737").style.display = "block";
      document.getElementById("__701").style.display = "block";
    }
    
  }

  return (
    <div className='v__code'>
        <div className='v__code_logo'>
            <Link to='/'>
                <img className='logo' src={Logo}/>
            </Link>    
        </div>
        <div className='v__code_text'>
            <h3>Change Password</h3>
        </div>
        <div className='v__code__blueSide'></div>
        <div className='v__code__center'>
            <input type="text" id='__307' value={verificationCode} onChange={e => setVerificationCode(e.target.value)} placeholder="Verification code"></input>
            <div className='v__code__error' id='587'><label id='424'>Invalid code</label></div>
            <div className='v__code__forgot'>
                <label className='v__code_goto' id='_237'>A verification code was sent to your email</label>
                <button onClick={onSubmitResend} id='_238'>Resend code</button>
            </div>
            <button onClick={onSubmit} id='_239'>Verify</button>
            <div className='v__code__center_s'>
                <input type="password" id='__727' value={password} onChange={e => setPassword(e.target.value)} placeholder="New password"></input>
                <div className='v__code__error' id='727'><label id='424'>Password required</label></div>
                <input type="password" id='__737' value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Confirm password"></input>
                <div className='v__code__error' id='465'><label id='424'>The passwords do not much!</label></div>
                <button onClick={onSubmitPass} id='__701' >Change password</button>
            </div>
        </div>
    </div>
  )
}

export default VerifyCode